
import {
  GET_SURVEYS_PREVIEW_SUCCESS,
  POST_SURVEY_SUCCESS
} from "../constants";


export const initialState = {
  surveyPreviewDetails: [],
};

export const surveyPreviewReducer = (state = initialState, action) => {
switch (action.type) {
  case GET_SURVEYS_PREVIEW_SUCCESS:
    
    return {
      ...state,
      surveyPreviewDetails: action.payload,
    };

  case POST_SURVEY_SUCCESS:
    
    return {
      ...state,
      surveyPreviewDetails: [...state.surveyPreviewDetails, action.payload],
    };

  default:
    return state;
}
};
